// extracted by mini-css-extract-plugin
export var turnNext = "animationLoops-module--turnNext--gosU2";
export var point = "animationLoops-module--point--9FbFj";
export var pointAnimation = "animationLoops-module--pointAnimation--UV6jU";
export var pageFiexd = "animationLoops-module--pageFiexd--9-EQK";